<script lang="ts">
    import { onDestroy, onMount } from 'svelte';
    import Router from 'svelte-spa-router';

    import AdvRetentionDialog from '../components/AdvRetentionDialog.svelte';
    import { CARD_END_PAGE_TYPE } from '../constants/imgList';
    import { EXPOSE_FAIL_SW } from '../enums/track';
    import routes from '../routers/cardEnd';
    import { startPreload } from '../stores/preloader';
    import { handleAppLoginSuccess } from '../utils/appLoginSuccess';
    import { prepareOmegaParams, trackEvent } from '../utils/track';

    import GlobalToast from '@/components/GlobalToast.svelte';
    import { reportP4Direct } from '@/utils/fmpTrack';
    import { showGlobalToast } from '@/utils/globalToast';
    import { attachOfflineToast } from '@/utils/offlineToast';

    let detachOfflineToast: (() => void) | undefined;

    startPreload(CARD_END_PAGE_TYPE);

    onMount(() => {
        reportP4Direct();

        prepareOmegaParams();

        detachOfflineToast = attachOfflineToast(showGlobalToast, () => {
            trackEvent(EXPOSE_FAIL_SW, {
                error_msg: 'page_offline_error',
                error_code: '1001'
            });
        });

        document.addEventListener('login', (event: Event) => {
            const customEvent = event as CustomEvent<{
                type: string;
                data: { ticket: string; cell: string; uid: string };
            }>;

            if (customEvent.detail?.type === 'success') {
                handleAppLoginSuccess(customEvent.detail.data);
            }
        });
    });

    onDestroy(() => {
        detachOfflineToast?.();
    });
</script>

<div class="app-card-end">
    <Router {routes} />
    <AdvRetentionDialog variant="end" />
    <GlobalToast />
</div>

<style lang="scss">
    .app-card-end {
        width: 7.5rem;
        margin: auto;
        overflow-x: hidden;
        -webkit-overflow-scrolling: touch;
    }

    :global(.app-card-end adv-cookie-notice) {
        z-index: 12;
    }

    :global(.app-card-end .phone-input-component.login-type-e .input-length-show),
    :global(.app-card-end .phone-input-component.login-type-e .input-length-show span),
    :global(
            .app-card-end
                .phone-input-component.login-type-e
                .input-length-show.is-input-complete
        ),
    :global(
            .app-card-end
                .phone-input-component.login-type-e
                .input-length-show.is-input-complete
                span
        ) {
        color: #ffffff;
    }

    :global(.app-card-end .phone-input-component.login-type-e .calling-code),
    :global(.app-card-end .phone-input-component.login-type-e .phone-input) {
        font-size: 0.3rem;
        line-height: 0.3rem;
    }

    :global(.app-card-end .phone-input-component.login-type-e .calling-code) {
        line-height: 0.42rem;
    }
</style>
